<script>
import simplebar from "simplebar-vue";
import i18n from "../i18n";
import Swal from "sweetalert2";
import { http } from "@/helpers/easyindustriaapi/config";

export default {
  data() {
    return {
      current_language: "br",
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/br.png"),
          language: "br",
          title: "Português BR",
        },
      ],
      user: null,
      empresa: null,
      notifications: [],
      notificationChannel: null,
      notificationsPollInterval: null,
    };
  },
  components: { simplebar },
  created() {
    i18n.locale = this.current_language;
    this.current_language = i18n.locale;
    try {
      this.user = JSON.parse(localStorage.getItem('user') || 'null') || {};
    } catch (_) {
      this.user = {};
    }
    try {
      this.empresa = JSON.parse(localStorage.getItem('currentEmpresa') || 'null') || {};
    } catch (_) {
      this.empresa = {};
    }

    // Configurar listener de notificações via Pusher
    this.setupNotifications();
  },
  mounted() {
    // Polling de notificações persistidas (recepção/admin veem notificações mesmo sem Pusher)
    const fetchNotifications = () => {
      if (!this.user || !this.user.id) return;
      http.get('/notifications').then(({ data }) => {
        const list = Array.isArray(data) ? data : (data && data.data) ? data.data : [];
        const existingIds = new Set(this.notifications.map((n) => n.id).filter((id) => typeof id === 'number'));
        for (const n of list) {
          if (!n || n.id == null) continue;
          if (n.recurrence_id != null && n.professional_aware) continue;
          if (existingIds.has(n.id)) continue;
          existingIds.add(n.id);
          this.notifications.unshift({
            id: n.id,
            titulo: n.titulo || 'Notificação',
            mensagem: n.mensagem || '',
            icone: n.icone || 'ri-notification-line',
            link: n.link || '#',
            horario: n.horario || 'agora',
            recurrence_id: n.recurrence_id ?? null,
            professional_aware: n.professional_aware ?? false,
          });
          this.emitUserNotificationBridge({
            id: n.id,
            titulo: n.titulo,
            mensagem: n.mensagem,
            icone: n.icone,
            link: n.link,
            horario: n.horario,
            recurrence_id: n.recurrence_id ?? null,
            professional_aware: n.professional_aware ?? false,
          });
        }
        this.notifications = this.notifications.filter((n) => !(n.recurrence_id && n.professional_aware));
        if (this.notifications.length > 50) this.notifications = this.notifications.slice(0, 50);
      }).catch(() => {});
    };
    fetchNotifications();
    this.notificationsPollInterval = setInterval(fetchNotifications, 25000);
  },
  beforeDestroy() {
    if (this.notificationsPollInterval) {
      clearInterval(this.notificationsPollInterval);
    }
    if (this.notificationChannel) {
      this.notificationChannel.unbind('nova.notificacao');
    }
  },
  computed: {
    // Capturar os números antes do 0001-XX do CNPJ
    empresaCNPJ() {
      if (!this.empresa || !this.empresa.cnpj) return ''
      const cnpj = this.empresa.cnpj;
      if (cnpj.length <= 6) return cnpj // Evita erro se o CNPJ for muito curto
      return cnpj.slice(0, -6)
    },
    // Verifica se usuário.roles é Admin, pertence ao super, partner ou admin
    isAdmin() {
      return this.user && this.user.roles
        ? this.user.roles.some(role => 
            ["super", "partner", "admin"].includes(role.name)
          )
        : false;
    },
    notificationsToShow() {
      return this.notifications.filter((n) => n.professional_aware !== true);
    },
    unreadNotificationsCount() {
      return this.notificationsToShow.length;
    },
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    openSettingsDrawer() {
      this.toggleRightSidebar();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },
    // Configurar listener de notificações via Pusher
    setupNotifications() {
      if (!this.user || !this.user.id) {
        console.warn('Usuário não encontrado. Notificações não serão configuradas.');
        return;
      }

      if (!window.pusher) {
        console.warn('Pusher não está disponível. Notificações não serão configuradas.');
        return;
      }

      // Canal privado: App.Models.User.{id}
      // No Pusher, canais privados são prefixados com 'private-'
      const channelName = `private-App.Models.User.${this.user.id}`;
      
      try {
        this.notificationChannel = window.pusher.subscribe(channelName);

        // Listener para sucesso na inscrição
        this.notificationChannel.bind('pusher:subscription_succeeded', () => {
          console.log('Inscrito no canal de notificações:', channelName);
        });

        // Listener para erro na inscrição
        this.notificationChannel.bind('pusher:subscription_error', (status) => {
          console.error('Erro ao inscrever no canal de notificações:', status);
        });

        // Listener para o evento 'nova.notificacao'
        this.notificationChannel.bind('nova.notificacao', (data) => {
          console.log('Nova notificação recebida:', data);
          const notifId = (data.id != null && Number.isInteger(data.id) && data.id > 0) ? data.id : Date.now() + Math.random();
          this.notifications.unshift({
            id: notifId,
            titulo: data.titulo || 'Nova Notificação',
            mensagem: data.mensagem || '',
            icone: data.icone || 'ri-notification-line',
            imagem: data.imagem || null,
            link: data.link || '#',
            horario: data.horario || 'agora',
            recurrence_id: data.recurrence_id || null,
            professional_aware: false,
          });

          // Limitar a 50 notificações mais recentes
          if (this.notifications.length > 50) {
            this.notifications = this.notifications.slice(0, 50);
          }

          this.emitUserNotificationBridge(data);

          // Opcional: Tocar som de notificação ou mostrar toast
          // this.showNotificationToast(data);
        });
      } catch (error) {
        console.error('Erro ao configurar notificações:', error);
      }
    },
    emitUserNotificationBridge(payload) {
      try {
        this.$root.$emit('easysaude:user-notification', payload);
      } catch (_) {
        /* noop */
      }
    },
    // Marca todas como lidas na API e limpa a lista local
    async clearNotifications() {
      try {
        await http.post('/notifications/mark-all-read');
      } catch (_) {
        // ignora erro; limpa a lista local mesmo assim
      }
      this.notifications = [];
    },
    // Método para lidar com clique na notificação
    async handleNotificationClick(notif) {
      if (!notif.link || notif.link === '#') return;
      const notifId = notif.id != null ? Number(notif.id) : null;
      const hasValidId = Number.isInteger(notifId) && notifId > 0 && notifId < 1000000;
      if (hasValidId) {
        try {
          await http.put(`/notifications/${notifId}/mark-read`);
        } catch (_) {
          // Ignora erro de rede; remove da lista mesmo assim
          void _;
        }
        const idx = this.notifications.findIndex((n) => n.id === notifId);
        if (idx !== -1) this.notifications.splice(idx, 1);
      }
      if (notif.link.startsWith('/')) {
        if (this.$route.path !== notif.link) {
          this.$router.push(notif.link);
        }
      } else {
        window.location.href = notif.link;
      }
    },
    isAuthorizedAttendanceNotification(notif) {
      return notif && (notif.titulo === 'Atendimento autorizado' || (notif.recurrence_id != null));
    },
    // Marcar recorrência como ciente (profissional está ciente da evolução/autorização)
    async markProfessionalAware(notif, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!notif) return;
      if (notif.professional_aware) return;
      try {
        if (notif.recurrence_id) {
          const empresa = JSON.parse(localStorage.getItem('currentEmpresa') || 'null');
          await http.put('/atendimento/recurrence/' + notif.recurrence_id + '/professional-aware', null, {
            params: { empresa_id: empresa && empresa.id },
          });
        } else if (Number.isInteger(notif.id) && notif.id > 0 && notif.id < 1000000) {
          await http.put('/notifications/' + notif.id + '/mark-professional-aware');
        } else {
          Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível marcar como ciente para esta notificação.' });
          return;
        }
        const idx = this.notifications.findIndex((n) => n === notif || (notif.id != null && n.id === notif.id) || (n.recurrence_id != null && n.recurrence_id === notif.recurrence_id && (n.titulo === notif.titulo && n.horario === notif.horario)));
        if (idx !== -1) this.notifications.splice(idx, 1);
        Swal.fire({ icon: 'success', title: 'Sucesso', text: 'Você marcou como ciente desta notificação.' });
      } catch (e) {
        const msg = e.response && e.response.data && (e.response.data.error || e.response.data.message) ? (e.response.data.error || e.response.data.message) : (e.message || 'Erro ao marcar como ciente.');
        Swal.fire({ icon: 'error', title: 'Erro', text: msg });
      }
    },
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- <a href="/" class="logo logo-light"> -->
          <router-link :to="(isAdmin) ? {name: 'home'} : {name: 'calendar'}" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm-light.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="20" />
            </span>
          </router-link>
          <!-- </a> -->
        </div>

        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item waves-effect"
          id="vertical-menu-btn"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input type="text" class="form-control" :placeholder="$t('navbar.search.text')" />
            <span class="ri-search-line"></span>
          </div>
        </form>

        <!-- Visível apenas em telas grandes -->
        <div class="top-company-name d-none d-lg-block px-3 mx-3 mt-3 pt-3 header-item">
          <h6 id="empresa-name">{{ empresaCNPJ }} {{ (empresa && empresa.apelido) || '' }}</h6>
        </div>
      </div>

      <div class="d-flex">
        <div class="dropdown d-inline-block d-lg-none ml-2">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            id="page-header-search-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="ri-search-line"></i>
          </button>
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-search-dropdown"
          >
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input type="text" class="form-control" :placeholder="$t('navbar.search.text')+' ...'" />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                      <i class="ri-search-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img
              :src="current_language === 'en' ? require('@/assets/images/flags/us.jpg') : require('@/assets/images/flags/br.png')"
              alt="Header Language"
              height="16"
            />
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`TopLang${i}`"
            :value="entry"
            @click="setLanguage(entry.language)"
            :link-class="{ active: entry.language === current_language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="language-flag"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            @click="initFullScreen"
            :title="$t('navbar.fullscreen.text')"
          >
            <i class="ri-fullscreen-line"></i>
          </button>
        </div>

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="ri-notification-3-line" :title="$t('navbar.dropdown.notification.text')"></i>
            <span v-if="unreadNotificationsCount > 0" class="badge badge-pill badge-danger badge-up">
              {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
            </span>
          </template>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ $t('navbar.dropdown.notification.text')}}</h6>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">{{ $t('navbar.dropdown.notification.subtext')}}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px;">
            <div
              v-for="(notif, index) in notificationsToShow"
              :key="notif.id || index"
              class="notification-item d-flex align-items-start text-reset"
            >
              <a
                :href="notif.link || '#'"
                class="flex-grow-1 text-reset text-decoration-none"
                @click.prevent="handleNotificationClick(notif)"
              >
                <div class="media">
                  <div class="avatar-xs mr-3">
                    <img
                      v-if="notif.imagem"
                      :src="notif.imagem"
                      class="rounded-circle avatar-xs"
                      alt="user-pic"
                    />
                    <span v-else class="avatar-title bg-primary rounded-circle font-size-16">
                      <i :class="notif.icone ? notif.icone : 'ri-notification-line'"></i>
                    </span>
                  </div>
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">{{ notif.titulo }}</h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">{{ notif.mensagem }}</p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ notif.horario }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
              <button
                v-if="isAuthorizedAttendanceNotification(notif)"
                type="button"
                :class="['btn btn-sm ml-2 align-self-center', notif.recurrence_id && !notif.professional_aware ? 'btn-success' : 'btn-secondary']"
                title="Estou ciente"
                @mousedown.stop
                @click.stop.prevent="markProfessionalAware(notif, $event)"
              >
                <i class="ri-checkbox-circle-fill font-size-16 mr-1"></i>
                Estou ciente
              </button>
            </div>

            <div v-if="notificationsToShow.length === 0" class="text-center p-3 text-muted">
              <p class="mb-0">Nenhuma notificação nova</p>
            </div>
          </simplebar>
          <div class="p-2 border-top">
            <a
              v-if="notificationsToShow.length > 0"
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              href="javascript:void(0)"
              @click.prevent="clearNotifications"
            >
              <i class="mdi mdi-check-all mr-1"></i>
              Limpar Notificações
            </a>
            <a
              v-else
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle mr-1"></i>
              {{ $t('navbar.dropdown.notification.button')}}
            </a>
          </div>
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
          :title="$t('navbar.dropdown.megamenu.text')"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/no-avatar.jpg"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ml-1">{{ (user && user.username) || '' }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <a class="dropdown-item" href="#">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.megamenu.profile.title') }}
          </a>
          <a class="dropdown-item" href="#">
            <i class="ri-lock-unlock-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.megamenu.look.title') }}
          </a>
          <a class="dropdown-item" href="https://tv.easysaude.click" target="_blank">
            <i class="ri-tv-line align-middle mr-1"></i>
            TV EasySaúde
          </a>
          <router-link :to="{name: 'SelectCompany'}" tag="a" class="dropdown-item">
            <i class="ri-lock-unlock-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.megamenu.selectcompany.title') }}
          </router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t('navbar.dropdown.megamenu.logout.title') }}
          </a>
        </b-dropdown>

        <div class="dropdown d-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect toggle-right"
            :title="$t('navbar.dropdown.megamenu.settings.title')"
            @click.prevent="openSettingsDrawer"
          >
            <i class="ri-settings-2-line"></i>
          </button>
        </div>


      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.notify-item {
  .active {
    color: #16181b;
    background-color: #f8f9fa;
  }
}
</style>